import { useParams } from "react-router-dom"
import { useUserApplications } from "../../../../../hooks/useUserApplications"
import { UserApplicationGet } from "../../../../models/UserApplication"
import {
  dateStringComparator,
  getNiceFormattedDate,
} from "../../../../utils/getFormattedDate"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function UserApplications() {
  const { userId } = useParams()
  const { userApplications, isLoadingUserApplications } = useUserApplications(userId)

  const cols = [
    { field: "name", headerName: "Name", flex: 1 },
    { field: "shortName", headerName: "Short name", flex: 0.5 },
    {
      field: "lastAccess",
      headerName: "Last access",
      renderCell: (row: EntityRow) => getNiceFormattedDate(String(row.lastAccess)),
      sortComparator: dateStringComparator,
      flex: 1,
    },
    { field: "version", headerName: "Version", flex: 1 },
    { field: "operatingSystem", headerName: "OS", flex: 0.5 },
  ]

  const rows: EntityRow[] = userApplications.map((app: UserApplicationGet) => ({
    id: app.id,
    name: app.application.name,
    shortName: app.application.shortName,
    lastAccess: app.lastAccess,
    version: app.version ?? "",
    operatingSystem: app.operatingSystem ?? "",
  }))

  return <EntityTab rows={rows} cols={cols} isLoading={isLoadingUserApplications} />
}
